module.exports = __webpack_public_path__ + "static/media/bts_veld_170806_011_small.6eadff62.jpg";